import { render, staticRenderFns } from "./CustomerEdition.vue?vue&type=template&id=3cc6bb7a&scoped=true"
import script from "./CustomerEdition.vue?vue&type=script&lang=js"
export * from "./CustomerEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6bb7a",
  null
  
)

export default component.exports